import api from "../services/api";
import { loaderAction } from "../utils/loader";
import { productQuantitySelector } from "../utils/product-input-quantity";
import { $Q, $Qll } from "../utils/query-selector";
import { realoadTrustpilot } from "../utils/reload-trustPilot-widget";
import { stringToHTML } from "../utils/to-html";
import { dataToggle } from "../utils/toggle-dataset";
import { btnAddToCart } from "./cart";
import { setupCustomSelect } from "./custom-select";
import { priceVat } from "./price-vat";
import { variantOnChange } from "./variants-product";
import { rewardPoints } from '../components/rewards-points';

/**
 *
 * detect when button is clicked for show product modal
 *
 * @param {String} variantsButtonQuery - query selector for buttons
 * @returns
 */
export const btnShowVariants = (variantsButtonQuery) => {
  const showVariantsButtons = $Qll(variantsButtonQuery);

  if (!showVariantsButtons) return;

  showVariantsButtons.forEach(
    (variantButton) => {
      variantButton.addEventListener('click', () => {
        const productHadle = variantButton.dataset.handle;
        // eslint-disable-next-line no-use-before-define
        openProductModal();
        // eslint-disable-next-line no-use-before-define
        renderModalSection(productHadle, "product-modal");

        //dataToggle($Q("#shopify-section-side-cart"), true);
      });

    },
  );
}

/**
 *
 * detect when button is clicked for show product modal just for Ajaxinate
 *
 * @param {String} variantsButton - query selector for buttons
 * @returns
 */
export const btnShowVariantsAjaxinate = (variantsButton) => {

  variantsButton.addEventListener('click', () => {
    const productHadle = variantsButton.dataset.handle;
    // eslint-disable-next-line no-use-before-define
    openProductModal();
    // eslint-disable-next-line no-use-before-define
    renderModalSection(productHadle, "product-modal");

    //dataToggle($Q("#shopify-section-side-cart"), true);
  });
}

/**
 * change data active to "true" when button is clicked
 */
const openProductModal = () => {
  const cartContainer = $Q(".cart");
  const productModal = $Q("#productModal");
  const sidecartClose = $Q('.cart-close');

  if (cartContainer && cartContainer.dataset.active === "true") {
    sidecartClose?.dispatchEvent(new Event("click"));
  }

  loaderAction(productModal);
  dataToggle(productModal);
  // eslint-disable-next-line no-undef
  document.body.classList.add("block-scroll")

  document.addEventListener('keydown', handleKeyPressClose);
}

/**
 * This function sets the position of the select options in a custom select element.
 * @param node - The HTML element that represents the custom select component.
 * @author Liska Loaiza <liska.loaiza@gradiweb.com>
 */
const setSelectVariantsPosition = (node) => {
  if (!node) return
  const selectOptions = node.querySelector('.custom-select__options');
  const selectContainer = node.querySelector('.custom-select');
  const selectHeight = selectContainer.offsetHeight;
  selectOptions.style.top = `${selectHeight}px`;
}

/**
 * add event to product modal when Escape key down
 */
export const handleKeyPressClose = (e) => {
  if (e.key === "Escape") {
    closeProductModal(true);
  }
}

/**
 * Change data active to "false" when close button is clicked
 */
export const closeProductModal = (cartAction) => {
  const closebutton = $Q(".modal__close");
  const productModal = $Q("#productModal");

  if (cartAction === true) {
    if (productModal.dataset.active === "true") {
      dataToggle(productModal);
      // eslint-disable-next-line no-undef
      document.body.classList.remove("block-scroll")
    }
    document.removeEventListener('keydown', handleKeyPressClose);
  } else {
    closebutton.addEventListener("click", () => {
      dataToggle(productModal);
      // eslint-disable-next-line no-undef
      document.body.classList.remove("block-scroll")
    })
  }
}

const renderModalSection = async (handle, sectionId) => {
  const locale = window.theme.lang === "fr" ? "" : `/${window.theme.lang}`;
  const base = `${locale}/products/${handle}`;

  const response = await api.shopifySectionByUrl(base, sectionId);

  // eslint-disable-next-line no-use-before-define
  updateContentModal(response);
}

const updateContentModal = (stringHTML) => {
  const modalContent = $Q(".modal__content", stringToHTML(stringHTML));
  const modalContentDom = $Q(".modal__content");

  loaderAction(modalContentDom);
  modalContentDom.innerHTML = modalContent.innerHTML;

  const modalWidget = $Q(".main-product__star-rating .trustpilot-widget");

  realoadTrustpilot(modalWidget);
  variantOnChange('.modal__content .variants');
  productQuantitySelector(modalContentDom);
  btnAddToCart('.modal__content .add-product-cart');
  closeProductModal(false);
  setupCustomSelect();
  priceVat();
  rewardPoints();
  setSelectVariantsPosition(modalContentDom)
}
